import { Flex, Link, useTheme } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function Footer() {
  const { tokens } = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    // @ts-expect-error - AWS Amplify UI type definitions incorrectly require HTML input properties
    <Flex
      alignItems="center"
      direction="column"
      gap=".5rem"
      padding={tokens.space.small}
    >
    </Flex>
  );
}
